import { Flex, Text } from '@stars-ecom/shared-atoms-ui'
import React from 'react'

import { priceFormat } from '../utils'

const Phone = (props) => {
  const { price = 0, phoneNumber = '', style = {}, height = '25px', fontSize = '13px', color } = props

  return (
    <Flex
      flex="0 0 auto"
      direction="row"
      alignItems="center"
      w="auto"
      style={{ height, fontFamily: 'arial', ...style }}
      className="phone-row">
      <Flex
        align="center"
        justify="center"
        pr="5px"
        style={{
          height,
          fontSize,
          fontWeight: 700,
          backgroundColor: '#fff',
          border: '1px solid #BBB'
        }}>
        <Text color={color} p="0 5px">{phoneNumber}</Text>
        <Flex
          _before={{
          content: `""`,
          position: 'absolute',
          display: 'block',
          border: '6px solid transparent',
          borderLeftColor: '#fff',
          marginLeft: '-10px'
          }}
          align="center"
          backgroundColor={color}
          fontSize="9px"
          h="110%"
          fontWeight="700"
          color="#fff"
          lineHeight="12px"
          paddingLeft={{ base: '9px', md: '10px' }}
          paddingRight="5px">
          <Flex direction="column">
            {price > 0 && (
              <Text>{`Service ${priceFormat(price, 'EUR')} / min`}</Text>
            )}
            {!price && (
              <Text>Service gratuit</Text>
            )}
            <Text>
              + prix appel
            </Text>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default Phone
